// extracted by mini-css-extract-plugin
export var root = "ZHWd";
export var rootButton = "rftK";
export var rootHeader = "Z9ib";
export var rootHeaderDate = "bQgt";
export var rootHeaderStars = "a5lY";
export var rootHeaderStarsStar = "WM1y";
export var rootItem = "INx+";
export var rootReview = "a+sd";